import React, { useEffect } from 'react';
import { Button, Typography } from '@mui/material';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { captureException } from '../Sentry';

import { usePublicConfig } from '../providers';

let version = process.env.REACT_APP_RELEASE_VERSION;
version ||= 'dev';

interface FallbackProps {
  error: Error;
}

const Fallback = ({ error }: FallbackProps) => {
  const { publicConfig } = usePublicConfig();

  useEffect(() => {
    console.error(error);
    captureException(error);
  }, []);
  const networkError = error.name === 'ChunkLoadError';
  const networkErrorText = "Sorry, we can't connect to the internet!";
  const otherErrorText = "We're Sorry, something went wrong on our end.";

  let errorText;
  if (networkError) {
    errorText = (
      <div>
        <div>{networkErrorText}</div>
        <div>Check your connection and click below to restart.</div>
        <div>
          Running{' '}
          <code style={{ padding: 4, background: '#ccc', borderRadius: 8 }}>
            v.{version}
          </code>{' '}
          of Perfect Venue
        </div>
      </div>
    );
  } else {
    errorText = (
      <div>
        <div>{otherErrorText}</div>
        <div>
          Running{' '}
          <code style={{ padding: 4, background: '#ccc', borderRadius: 8 }}>
            v.{version}
          </code>{' '}
          of Perfect Venue
        </div>
      </div>
    );
  }
  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography align="center" variant="h2" style={{ margin: 20 }}>
        {!networkError && (
          <img
            alt="logo"
            style={{ width: 300, height: 'auto' }}
            src={publicConfig.images?.pvLogoName}
          />
        )}
      </Typography>
      <Typography align="center" style={{ margin: 20 }} component="div">
        {errorText}
        {!networkError && (
          <>
            <br />
            <br /> Our team has been notified and is looking into the problem
            now.
          </>
        )}
      </Typography>
      <Button
        color="secondary"
        variant="contained"
        style={{ margin: 20 }}
        onClick={() => {
          window.location.href = '/';
        }}
      >
        Click To Restart
      </Button>
    </div>
  );
};

interface WrapperProps {
  children: any;
}

export const ErrorBoundary = ({ children }: WrapperProps) => (
  <ReactErrorBoundary FallbackComponent={Fallback}>
    {children}
  </ReactErrorBoundary>
);
